import React from 'react';
import { Link } from 'react-router-dom';
import useAsync from '../../hooks/useAsync';
import ComanServices from '../../services/ComanServices';
import { POLICY_DEFAULTS, hasRealPolicyContent, readPolicy } from './policyDefaults';
import './PolicyPage.css';

const RELATED = [
  ['/privacy-policy', 'privacyPolicy', 'Privacy Policy'],
  ['/term-and-services', 'termsAndCondition', 'Terms & Conditions'],
  ['/cancelpolicy', 'canclePolicy', 'Cancellation & Refund'],
];

// Public policy page: the content saved in Admin → (policy), or the recommended text when
// nothing has been saved yet. `policyKey` is privacyPolicy | termsAndCondition | canclePolicy.
function PolicyPage({ policyKey, icon }) {
  const { data, isLoading } = useAsync(ComanServices.getPolicy);
  const record = data?.data;
  const saved = readPolicy(record, policyKey);
  const policy = hasRealPolicyContent(saved) ? saved : POLICY_DEFAULTS[policyKey];
  const title = (hasRealPolicyContent(saved) && saved?.title) || POLICY_DEFAULTS[policyKey].title;
  const updated = record?.updated_at || record?.updatedAt || record?.created_at;
  const updatedLabel = updated && !Number.isNaN(new Date(updated).getTime())
    ? new Date(updated).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' })
    : null;

  return (
    <section className="pol-page">
      <header className="pol-hero">
        <span className="pol-icon"><i className={`fa ${icon}`} aria-hidden="true" /></span>
        <div>
          <span className="pol-eyebrow">Legal</span>
          <h1>{title}</h1>
          {updatedLabel && <p className="pol-updated">Last updated: {updatedLabel}</p>}
        </div>
      </header>

      <div className="pol-layout">
        <article className="pol-card">
          {isLoading && !data
            ? <p className="pol-muted">Loading…</p>
            : <div className="pol-content" dangerouslySetInnerHTML={{ __html: policy?.description || '' }} />}
        </article>

        <aside className="pol-side">
          <div className="pol-card pol-side-card">
            <h2>Policies</h2>
            <ul>
              {RELATED.map(([to, key, label]) => (
                <li key={to}>
                  <Link to={to} className={key === policyKey ? 'active' : ''}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="pol-card pol-side-card">
            <h2>Need help?</h2>
            <p className="pol-muted">Questions about this policy? Reach our support team.</p>
            <Link to="/contact" className="pol-btn">Contact us</Link>
          </div>
        </aside>
      </div>
    </section>
  );
}

export default PolicyPage;
